import { lazy } from 'react'

import Wrapper from '../../layouts/wrapper'
import { useMeQuery } from '../../store/api'
import {
  CompanyStatus,
  CompanyStatusInfoMessageMap,
} from '../../store/types/company'

const Pricing = lazy(async () => await import('./billing-pricing/pricing'))

interface CompanyStatusProps {
  status: CompanyStatus
}

export function CompanyStatusCheckView(): JSX.Element {
  const { data: meData } = useMeQuery()
  return (
    <Wrapper>
      <Body status={meData.status} />
    </Wrapper>
  )
}

function Body({ status }: CompanyStatusProps): JSX.Element {
  const title = CompanyStatusInfoMessageMap[status].title
  const message = CompanyStatusInfoMessageMap[status].message

  const showBillingPage: boolean = status === CompanyStatus.EXPIRED

  return (
    <>
      <div>
        <div className="flex flex-col justify-between md:flex-row pb-5 border-b-2 border-solid border-gray-200">
          <div className="flex flex-col ">
            <h1 className="font-normal text-3xl text-gray-900 pb-2.5">
              {title}
            </h1>
            <span className="font-normal text-lg text-gray-600">{message}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col mt-6">
        {showBillingPage && <Pricing hideBreadcrumbs={true} />}
      </div>
    </>
  )
}
